import React from "react";
import YoutubeVideoCard from "components/Web_User_Interface/1440p_Series/YoutubeVideoCard";

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiHideFor,
} from "@elastic/eui";

import IntroCards from "./IntroWebUI1440ToC";
import IntroCardsMobile from "./IntroWebUI1440ToC_mobile";

export default function IntroHome() {
  return (
    <React.Fragment>
      <EuiSpacer />
      <EuiTitle size="m">
        <h2>INSTAR UltraHD Series (2K+ 1440p & 4K 2160p) Web User Interface</h2>
      </EuiTitle>
      <EuiSpacer />
      <YoutubeVideoCard />
      <EuiSpacer />
      <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup
        gutterSize="l"
        direction="column"
        style={{ margin: "0 7px" }}
      >
        <EuiFlexItem>
          <EuiHideFor sizes={["xs", "s", "m", "l"]}>
            <IntroCards />
          </EuiHideFor>
          <EuiHideFor sizes={["xl"]}>
            <IntroCardsMobile />
          </EuiHideFor>
        </EuiFlexItem>
      </EuiFlexGroup>
    </React.Fragment>
  );
}
